<script lang="ts" setup>
  import { useToast } from '@travelata-libs/ui-kit';
  import { LeadBanner, type LeadBannerPayload } from '@travelata-libs/ui-shared';
  import { ref } from 'vue';
  import { setLeadCookie, checkLeadSession } from './lib';
  import { createLead } from '@/shared/api/createLead';
  import { useTravelataAppConfig } from '@/shared/composables';

  interface LeadBannerProps {
    title: string;
    subtitle: string;
    modalTitle?: string;
  }

  withDefaults(defineProps<LeadBannerProps>(), {
    modalTitle: undefined,
  });

  const formRef = ref<InstanceType<typeof LeadBanner> | null>(null);
  const { showToast } = useToast();
  const appConfig = useTravelataAppConfig();

  const isSubmitted = ref<boolean>(checkLeadSession());
  const loading = ref<boolean>(false);
  const model = ref<LeadBannerPayload>({ phone: '', name: '' });
  const onSubmit = async (data: LeadBannerPayload) => {
    isSubmitted.value = false;
    loading.value = true;
    try {
      await createLead(data);
      setLeadCookie();
      isSubmitted.value = true;
      formRef.value?.closeModal();
    } catch {
      showToast({
        type: 'error',
        title: 'Что-то пошло не так',
        description: 'Заявка не отправлена. Попробуйте ещё раз.',
      });
    } finally {
      loading.value = false;
    }
  };
</script>

<template>
  <LeadBanner
    ref="formRef"
    v-model="model"
    appearance="compact"
    :title="title"
    :subtitle="subtitle"
    :user-agreement-url="appConfig.legalDocuments.user_agreement"
    :privacy-policy-url="appConfig.legalDocuments.privacy"
    :data-processing-url="appConfig.legalDocuments.personal_data_agreement"
    :is-submitted="isSubmitted"
    :loading="loading"
    :modal-title="modalTitle"
    class="lead-banner"
    @submit="onSubmit"
  ></LeadBanner>
</template>
